import { useEffect, useState } from 'react';
import { off, on } from './util';
var useBattery = function () {
    var _a = useState({}), state = _a[0], setState = _a[1];
    var mounted = true;
    var battery = null;
    var onChange = function () {
        var charging = battery.charging, level = battery.level, chargingTime = battery.chargingTime, dischargingTime = battery.dischargingTime;
        setState({
            charging: charging,
            level: level,
            chargingTime: chargingTime,
            dischargingTime: dischargingTime,
        });
    };
    var onBattery = function () {
        onChange();
        on(battery, 'chargingchange', onChange);
        on(battery, 'levelchange', onChange);
        on(battery, 'chargingtimechange', onChange);
        on(battery, 'dischargingtimechange', onChange);
    };
    useEffect(function () {
        navigator.getBattery().then(function (bat) {
            if (mounted) {
                battery = bat;
                onBattery();
            }
        });
        return function () {
            mounted = false;
            if (battery) {
                off(battery, 'chargingchange', onChange);
                off(battery, 'levelchange', onChange);
                off(battery, 'chargingtimechange', onChange);
                off(battery, 'dischargingtimechange', onChange);
            }
        };
    }, []);
    return state;
};
export default useBattery;
